/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import axios from 'axios';
import { Select, DatePicker, Drawer, Tree, Modal, Input, Button } from 'antd';
import Panel from './Panel';
import NewDashboard from './NewDashboard';
import localStorage from '../../../utils/localStorage';
import station from '../Utils/Images/Stations_V1.png';
import DayMonthYearSelection from '../DashboardComponents/Widgets/Selection/DayMonthYearSelection';
import HierarchyDropdownSelection from './Widgets/Selection/HierarchyDropdownSelection';
import { connect } from 'react-redux';
import { getDashboardByName } from './DashboardCalls';
import { DashboardDiv, DashboardHeaderDiv } from './CSS/styles.js';
import HierarchyModal from '../DashboardComponents/Widgets/Selection/HierarchyModal.js';

import './CSS/Dashboard.css';
import { DownOutlined, UpSquareOutlined } from '@ant-design/icons';
import { API_DEVICE } from '../../../commons/api.js';
import MultiLevelDashboard from '../Custom/MultiLevelDashboard';
// import './CSS/Dashboard.css'; 
import weekOfYear from 'dayjs/plugin/weekOfYear';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { useParams } from 'react-router-dom';


const { MonthPicker, RangePicker } = DatePicker;
const { Option } = Select;

const Dashboard = (props) => {
  const [dashboardName, setDashboardName] = useState('');
  const [visible, setVisible] = useState(false);
  const [panels, setPanels] = useState([]);
  const [headerJSON, setHeaderJSON] = useState({});
  const [hierarchydata, setHierarchyData] = useState('');
  const [checkedValue, setCheckedValue] = useState([]);
  // const [graphDataForEdit, setGraphDataForEdit] = useState('');
  const [translationCacheState, setTranslationCache] = useState(props.translationCache || {});

  // const [selectionDate, setSelectionDate] = useState(dayjs().format('YYYY-MM-DD 00:00:00'));
  // const [showDateRange, setShowDateRange] = useState(false);
  // const [selectionDateRange, setSelectionDateRange] = useState({
  //   startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
  //   endDate: dayjs().format('YYYY-MM-DD HH:mm:ss')
  // });
  const [deviceList, setDeviceList] = useState([]);
  // const [selectionMonth, setSelectionMonth] = useState(dayjs().format('YYYY-MM'));
  // const [selectionWeek, setSelectionWeek] = useState(dayjs().startOf('week'));
  const [shift,] = useState('Morning Shift');
  const [loading, setLoading] = useState(true);
  // const [selectedThemeing, setSelectedThemeing] = useState(props.selectedThemeing);
  const [selectedTheme] = useState(props.selectedTheme);
  const [dropdownSelection, setDropdownSelection] = useState({});
  const [treeList, setTreeList] = useState([]);
  // const [isDeviceCodeFromSelect,setIsDeviceCodeFromSelect]= useState(false);

  const [AssetName, setAssetName] = useState('');
  const [AssetCode, setAssetCode] = useState('');
  const [AssetObject, setAssetObject] = useState({});
  const [DeviceCode, setDeviceCode] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dayMonthYear, setDayMonthYear] = useState({});
  const [selectionDate, setSelectionDate] = useState(dayjs().format('YYYY-MM-DD 00:00:00'));
  const [selectionDateRange, setSelectionDateRange] = useState({
    startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
    endDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
  });
  const [selectionMonth, setSelectionMonth] = useState(dayjs().format('YYYY-MM'));
  const [selectionWeek, setSelectionWeek] = useState(dayjs().startOf('week'));

  dayjs.extend(weekOfYear);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  dayjs.extend(advancedFormat);

  useEffect(() => {
    if (props.translationCache !== translationCacheState) {
      setTranslationCache(props.translationCache);
    }
    // if (headerJSON && headerJSON.hierarchyViewType === "Tree Drawer") {
    //   // setDeviceCode('All');
    //   // setIsDeviceCodeFromSelect(true);
    // }
  }, [props.translationCache,headerJSON]);

  const hookParams = useParams();
  let params = props.match && props.match.params && Object.keys(props.match.params).length ? props.match.params
    : (Object.keys(hookParams).length && hookParams.name ? hookParams : {});

  useEffect(() => {
    let dashboardName = "";

    if (params) {
      if (params && params.name) {
        dashboardName = params.name;
      }
      document.title = 'Dashboard-' + dashboardName;
      if (dashboardName === 'FFT') {
        let DeviceCode = props.params.DeviceAlias;
        selectDashboard(dashboardName, DeviceCode);
      } else {
        selectDashboard(dashboardName);
      }
    } else {
      const path = props && props.params && props.params['*'];
      const splitPath = path && path !== undefined && path.split('/');
      let dashboardName = splitPath && splitPath[splitPath.length - 1];
      document.title = 'Dashboard-' + dashboardName;
      if (dashboardName === 'FFT') {
        let DeviceCode = props.params.DeviceAlias;
        selectDashboard(dashboardName, DeviceCode);
      } else {
        selectDashboard(dashboardName);
      }
    }
    // getHierarchyLevels();

  }, [params.name]);

  const _getDevicesList = async (payload) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let url = payload && payload.method === 'GET' && payload.GETParams
      ? `${payload.url}?SiteId=${siteId}&${payload.GETParams}`
      : `${payload.url}?SiteId=${siteId}`;

    let payloadData = payload && payload.payload ? payload.payload : '';
    const ObjectHeader = {
      method: payload.method,
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payloadData || {}
    };

    try {
      const response = await axios(ObjectHeader);
      return response.data;
    } catch {
      return [];
    }
  };
  
  const disabledDate = (current) => {
    let selectionPoint = '0';
    if (headerJSON && headerJSON.DashboardLevelSelection && headerJSON.DashboardLevelSelection !== 'none') {
      selectionPoint = headerJSON.json && headerJSON.json[0] && headerJSON.json[0].DashboardLevelSelectionPoint === 'PreviousDay' ? '1' : '0';
    } else if (headerJSON && headerJSON.json && headerJSON.json[0] && headerJSON.json[0].GraphLevelSelection !== 'none') {
      selectionPoint = headerJSON.json[0].GraphLevelSelectionPoint === 'PreviousDay' ? '1' : '0';
    }
    return current > dayjs().startOf('day').subtract(selectionPoint, 'day');
    // return current && current.isAfter(dayjs().endOf('day'));
  };

  const onChangeDatePicker = (date) => {
    if (date) {
      setSelectionDate(dayjs(date).format('YYYY-MM-DD 00:00:00'));
    } else {
      setSelectionDate(dayjs().format('YYYY-MM-DD 00:00:00'));
    }
  };

  const onDateRangePickerChange = (dates) => {
    if (dates && dates.length === 2) {
      setSelectionDateRange({
        startDate: dayjs(dates[0]).format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs(dates[1]).format('YYYY-MM-DD HH:mm:ss'),
      });
    } else {
      setSelectionDateRange({
        startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      });
    }
  };

  const onChangeMonthPicker = (date, dateString) => {
    setSelectionMonth(dateString);
  };

  const selectionpayload = (payload) => {
    setDayMonthYear(payload);
  };

  const hierarchyDropdownChange = (value, hierarchydata, deviceList) => {
    let selectedValue = value && Array.isArray(value) && value.length > 0 ? value[0] : undefined;
    if (selectedValue) {
      setIsModalVisible(false);
      setDropdownSelection(prev => ({ ...prev, DeviceCode: selectedValue }));
      setDeviceList(deviceList);
      setCheckedValue(value);
      setHierarchyData(hierarchydata);
    }
  };

  const onTreeSelect = async (keys, nodeobject) => {
    const findParent = (key, tree) => {
      for (let node of tree) {
        if (node.children) {
          for (let child of node.children) {
            if (child.key === key) {
              return node;
            }
          }
          const result = findParent(key, node.children);
          if (result) return result;
        }
      }
      return null;
    };
    let payload = {
      ...(headerJSON && headerJSON.apiPayload ? headerJSON.apiPayload : {}),
      payload: {
        ...(headerJSON && headerJSON.apiPayload && headerJSON.apiPayload.payload ? headerJSON.apiPayload.payload : {}),
        AssetCode: keys && keys[0] ? keys[0] : '',
        // DeviceCode: keys && keys[0] ? keys[0] : '',
      }
    };
    const parentNode = findParent(keys && keys[0] ? keys[0] : '', treeList[0].children);
    let drawerListOnchange = await _getDevicesList(payload);
    const finalData = drawerListOnchange && Array.isArray(drawerListOnchange) ? drawerListOnchange.map(userHierarchy => renameProperty(userHierarchy, 'Name', 'title', 'Code', 'key')) : [];
    let deviceCodeList = await ChildrenNames(finalData, []);
    // if (deviceCodeList && deviceCodeList[0] && deviceCodeList[0].key) {
    //  DeviceCode = deviceCodeList[0].key;
    // }
    let deviceList = deviceCodeList;
    setAssetCode(keys && keys[0] ? keys[0] : '');
    setAssetName(nodeobject && nodeobject.node ? nodeobject.node.title : '');
    setAssetObject({ Station: parentNode ? parentNode.title : '' });
    setDeviceList(deviceList);
    setDeviceCode(
      headerJSON.hierarchyViewType === "Tree Drawer" 
        ? keys[0] || ''
        : deviceList[0]?.Value || ''
    );
    // setIsDeviceCodeFromSelect(false);
    // setDeviceCode(headerJSON && headerJSON.hierarchyViewType === "Tree Drawer" ? keys && keys[0] ? keys[0] : '' : deviceList && deviceList[0] && deviceList[0].Value ? deviceList[0].Value : '');
  };

  const getFormattedTreeData = (treeData) => {
    return treeData && Array.isArray(treeData) ? treeData.map((treeObject) => {
      if (treeObject && treeObject.children && Array.isArray(treeObject.children) && treeObject.children.length > 0) {
        let children = getFormattedTreeData(treeObject.children);
        return {
          title: treeObject.Name,
          key: treeObject.Code,
          Type:treeObject.Type,
          children
        };
      } else {
        return {
          title: treeObject.Name,
          key: treeObject.Code,
          Type:treeObject.Type,
        };
      }
    }) : [];
  };

  const selectDashboard = async (dashboardName) => {
    if (dashboardName === 'newdashboard') {
      setPanels([]);
      setDashboardName(dashboardName);
      setSelectionDate(dayjs().format('YYYY-MM-DD HH:mm:ss'));
      setSelectionDateRange({
        startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs().format('YYYY-MM-DD HH:mm:ss')
      });
      setSelectionMonth(dayjs().format('YYYY-MM'));
      setSelectionWeek(dayjs().startOf('week'));
    } else {
      await getDashboard(dashboardName);
    }
  };

  const getDashboard = async (dashboardName) => {
    let deviceList = [];
    let treeList = [];
    let AssetCode = '';
    let AssetName = '';
    let AssetObject = {};
    let DeviceCode = '';
    let dashboardObject = await getDashboardByName(dashboardName);
    let dashboards = dashboardObject && dashboardObject[0] ? dashboardObject[0] : {};

    if (dashboards) {
      if (dashboards && dashboards.headerJSON && dashboards.headerJSON.hierarchyViewType === "Tree Drawer") {
        if (dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload && dashboards.headerJSON.apiPayload.method && dashboards.headerJSON.apiPayload.url) {
          let treeListData = await _getDevicesList(dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload);
          treeList = getFormattedTreeData(treeListData);
          let defaultData = await collectDeviceNodes(treeList, []);
          // AssetCode = defaultData && defaultData[0] && defaultData[0].key ? defaultData[0].key : '';
          DeviceCode = defaultData && defaultData[0] && defaultData[0].key ? defaultData[0].key : '';
          AssetName = defaultData && defaultData[0] && defaultData[0].title ? defaultData[0].title : '';
          AssetObject = defaultData && defaultData[0] ? defaultData[0] : {};
        } else {
          treeList = [];
        }
      }

      if (dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload && dashboards.headerJSON.apiPayload.method && dashboards.headerJSON.apiPayload.url
        && dashboards.headerJSON.hierarchyViewType === "Select"
        ) {
        if (dashboards && dashboards.headerJSON && treeList && treeList[0] && treeList[0].key) {
          let payload = {
            ...(dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload ? dashboards.headerJSON.apiPayload : {}),
            payload: {
              ...(dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload && dashboards.headerJSON.apiPayload.payload ? dashboards.headerJSON.apiPayload.payload : ''),
              // AssetCode: AssetCode,
              // DeviceCode:DeviceCode
            }
          };
          let drawerList = await _getDevicesList(payload);
          const finalData = drawerList && Array.isArray(drawerList) ? drawerList.map(userHierarchy => renameProperty(userHierarchy, 'Name', 'title', 'Code', 'key')) : [];
          const deviceNodes = collectDeviceNodes(finalData,[]);
          deviceList = deviceNodes;
          DeviceCode = deviceNodes.length > 0 ? deviceNodes[0].key : null;
        } else {
          deviceList = await _getDevicesList(dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload);
          DeviceCode = deviceList && deviceList[0] && deviceList[0].Value ? deviceList[0].Value : '';
        }
      }

      if (dashboards && dashboards.headerJSON && dashboards.headerJSON.hierarchyViewType === "Tree Select" ||
        dashboards.headerJSON.hierarchyViewType === 'Tree Modal'
      ) {
        let hierarchyData = await _getDevicesList(dashboards && dashboards.headerJSON && dashboards.headerJSON.apiPayload);
        const final = hierarchyData && Array.isArray(hierarchyData) ? hierarchyData.map(userHierarchy => renameProperty(userHierarchy, 'Name', 'title', 'Code', 'key')) : [];
        // let deviceCodeList = await ChildrenNames(final, []);
        const deviceNodes = collectDeviceNodes(final,[]);
        DeviceCode = deviceNodes.length > 0 ? deviceNodes[0].key : null;
        let payload = {
          url: `${API_DEVICE.GET}`,
          method: 'GET'
        };
        deviceList = await _getDevicesList(payload);
        hierarchyDropdownChange([DeviceCode], hierarchyData, deviceList);
      }

      let dayMonthYear = {};
      let defaultSelection = '0';
      if (dashboards && dashboards.headerJSON && dashboards.headerJSON.DashboardLevelSelection !== 'none') {
        defaultSelection = dashboards.headerJSON.DashboardLevelSelectionPoint === 'PreviousDay' ? '1' : '0';
      } else if (dashboards.json && dashboards.json[0] && dashboards.json[0].GraphLevelSelection !== 'none') {
        defaultSelection = dashboards.json[0].GraphLevelSelectionPoint === 'PreviousDay' ? '1' : '0';
      }

      if (dashboards && dashboards.headerJSON && dashboards.headerJSON.DashboardLevelSelection === 'dateMonthYearPicker' && dashboards.headerJSON.TimeBucket && Object.keys(dashboards.headerJSON.TimeBucket).length > 0) {
        let tb = dashboards.headerJSON.TimeBucket;
        if (Object.keys(tb)[0] === 'Day') {
          dayMonthYear = {
            StartDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD 00:00:00'),
            EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD 23:59:59'),
            TimeBucket: tb['Day'],
            SelectionType: 'Day'
          };
        } else if (Object.keys(tb)[0] === 'Week') {
          dayMonthYear = {
            StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
            EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
            TimeBucket: tb['Week'],
            SelectionType: 'Week'
          };
        } else if (Object.keys(tb)[0] === 'Month') {
          dayMonthYear = {
            StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
            EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
            TimeBucket: tb['Month'],
            SelectionType: 'Month'
          };
        } else if (Object.keys(tb)[0] === 'Year') {
          dayMonthYear = {
            StartDate: dayjs().format('YYYY-MM-DD 00:00:00'),
            EndDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss'),
            TimeBucket: tb['Year'],
            SelectionType: 'Year'
          };
        }
      }

      setPanels(dashboards.json);
      setHeaderJSON(dashboards.headerJSON || {});
      setDashboardName(dashboards.Name);
      setLoading(false);
      setDeviceList(deviceList);
      setTreeList(treeList);
      setDeviceCode(dashboards && dashboards.headerJSON && dashboards.headerJSON.hierarchyViewType === "Tree Drawer" ? DeviceCode : deviceList && deviceList[0] && deviceList[0].Value ? deviceList[0].Value : '');
      setAssetCode(AssetCode);
      setAssetName(AssetName);
      setAssetObject(AssetObject);
      setSelectionDate(dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD 00:00:00'));
      setSelectionMonth(dayjs().format('YYYY-MM'));
      setSelectionWeek(dayjs().startOf('week'));
      setSelectionDateRange({
        startDate: dayjs().subtract(defaultSelection, 'day').subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss'),
        endDate: dayjs().subtract(defaultSelection, 'day').format('YYYY-MM-DD HH:mm:ss')
      });
      setDayMonthYear(dayMonthYear);
    } else {
      setLoading(false);
      setPanels([]);
      setHeaderJSON({});
      setDashboardName('');
      setSelectionDate(dayjs().format('YYYY-MM-DD HH:mm:ss'));
      setSelectionDateRange({
        startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD HH:mm'),
        endDate: dayjs().format('YYYY-MM-DD HH:mm')
      });
      setSelectionMonth(dayjs().format('YYYY-MM'));
      setSelectionWeek(dayjs().startOf('week'));
    }
  };

  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   console.log(obj.children.Type,'renameProperty',obj);
  //   if (obj && obj.children) {
  //     const children = obj.children.map((child) =>
  //       renameProperty(child, oldName1, newName1, oldName2, newName2)
  //     );
  //     return {
  //       ...obj,
  //       [newName1]: obj[oldName1],
  //       [newName2]: obj[oldName2],
  //       children: children
  //     };
  //   }
  //   return {
  //     ...obj,
  //     [newName1]: obj[oldName1],
  //     [newName2]: obj[oldName2]
  //   };
  // }
  const collectDeviceNodes = (tree, result = []) => {
    tree.forEach(node => {
      if (node.Type === "Device") {
        result.push(node);
      }
      if (node.children && node.children.length > 0) {
        collectDeviceNodes(node.children, result);
      }
    });
    return result;
  };
  const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
    const children = obj.children
      ? obj.children.map(child => renameProperty(child, oldName1, newName1, oldName2, newName2))
      : [];
    return {
      ...obj,
      [newName1]: obj[oldName1],
      [newName2]: obj[oldName2],
      children
    };
  };

  const ChildrenNames = (obj) => {
    if (!obj || !obj[0] || !obj[0].children) return [];

    return obj[0].children.map((subChildren) => ({
      key: subChildren.key,
      title: subChildren.title,
      Type: subChildren.Type,
      Station: ''
    }));
  };

  const editGraph = (graphData) => {
    localStorage.set('graphData', JSON.stringify(graphData));
    props.navigate({
      pathname: `/rubus/dashboard/editpanel/${graphData.dashboardName}/${graphData.id}?kiosk=false`,
      selection: {
        DeviceCode,
        selectionDate,
        selectionMonth,
        selectionWeek,
        selectionDateRange,
        dayMonthYear,
        shift
      }
    });
  };

  const drilldownRedirect = (url) => {
    props.navigate(`/dashboard/${url}`);
  };

  const translation = (keyword) => {
    return props.translationCache && props.translationCache[keyword] ? props.translationCache[keyword] : keyword;
  };


  const colorTheme = selectedTheme;
  const styles = {
    background: colorTheme
  };

  let filteredDevice =
  dropdownSelection && dropdownSelection.DeviceCode
    ? deviceList && Array.isArray(deviceList) && deviceList.filter((device) => device.AliasCode === dropdownSelection.DeviceCode)
    : '';

    console.log(headerJSON,'returnnnnnnnffsgsgsgsh');

  if (dashboardName === 'newdashboard') {
    return (
      <NewDashboard
        DeviceData={props.DeviceData}
        AssetData={props.AssetData}
        panels={panels}
      />
    );
  } else if (headerJSON && headerJSON.isMultiLevelDashboard === 'true') {
    return <MultiLevelDashboard dashboards={headerJSON} />;
  } else {
    return (
      <DashboardDiv className={'testDiv'} id="testdiv" style={styles}>
        <div
          style={{
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-evenly',
            fontWeight: 'bold'
          }}>
          {AssetName.length !== 0
            ? `Station Name : ${AssetName} ${AssetObject && AssetObject.Station ? `(${AssetObject.Station})` : ''
            }`
            : null}
        </div>
        {headerJSON &&
          headerJSON.hierarchyViewType === 'Tree Modal' ? (
          <span
            style={{
              height: '30px',
              display: 'flex',
              justifyContent: 'flex-start',
              flexFlow: 'row wrap',
              marginTop: '10px'
            }}>
            <Input
              placeholder={translation['Select sensor'] || 'Select sensor'}
              value={
                  filteredDevice &&
                  Array.isArray(filteredDevice) &&
                  filteredDevice[0] &&
                  filteredDevice[0].Name
                    ? `${
                        filteredDevice[0].Name
                          ? `${translation(filteredDevice[0].Name)}`
                          : ''
                      }`
                    : ''
                }

              style={{ width: 300, opacity: 1, height: '32px' }}
            />
            <Button
              type="primary"
              style={{ marginRight: '5px' }}
              onClick={() => setIsModalVisible(!isModalVisible)}>
              <UpSquareOutlined />
            </Button>
            <Modal
              title={translation('Select Hierarchy')}
              className="hierarchyModal"
              open={isModalVisible}
              bodyStyle={{ overflowY: 'scroll', height: '900px' }}
              footer={null}
              onCancel={() => setIsModalVisible(false)}>
              <HierarchyModal
                value={
                  dropdownSelection && Object.keys(dropdownSelection).length > 0
                    ? dropdownSelection.DeviceCode
                    : DeviceCode
                }
                checkedArray={checkedValue || []}
                treeData={hierarchydata}
                translationCache={props.translationCache}
                handleDropdownChange={hierarchyDropdownChange}
                deviceList={deviceList}
                dashboards={headerJSON}
              />
            </Modal>
            {dashboardName === 'Vibration Sensor' && (
              <>
                <Button
                  type="primary"
                  style={{ marginRight: '5px' }}
                  onClick={() => props.navigate('/rubus/LogBook/Vibration Sensor Field Entry')}>
                  {translation('Redirect to logbook')}
                </Button>
                <Button
                  type="primary"
                  style={{ marginRight: '5px' }}
                  onClick={() =>
                    props.navigate(`/rubus/FFT?deviceCode=${dropdownSelection.DeviceCode}`)
                  }>
                  {translation('FFT')}
                </Button>
              </>
            )}
          </span>
        ) : null}
        {headerJSON
          && headerJSON.hierarchyViewType === "Tree Drawer" ? (
          // Station
          <div className="drawerToggle">
            <div onClick={() => setVisible(true)}>
              <img
                src={station}
                alt="logo"
                height={'50'}
                width={'50'}
                style={{ marginTop: '8px', width: '200%' }}
              />
            </div>
            <Drawer
              className="drawerBlackTheme"
              title="Select Tree"
              placement={'left'}
              closable={false}
              onClose={() => setVisible(false)}
              open={visible}
              key={'left'}>
              <Tree
                className="treeBlackTheme"
                showLine
                value={DeviceCode}
                selectedKeys={DeviceCode ? [DeviceCode] : []}
                defaultExpandAll={true}
                switcherIcon={<DownOutlined />}
                onSelect={(selectedValue, nodeObject) =>
                  onTreeSelect(selectedValue, nodeObject)
                }
                treeData={Array.isArray(treeList) ? treeList : []}
              />
            </Drawer>
          </div>
        ) : null}
        {
          (headerJSON &&
            headerJSON.hierarchyViewType === 'Select' ) ||
            // headerJSON.dashboardType === 'multi' ||
            // (headerJSON &&
            // headerJSON.dashboardType === 'hierarchy' &&
            // headerJSON.hierarchyViewType === 'Select') ||
            (headerJSON && headerJSON.DashboardLevelSelection !== 'none') ? (
            <DashboardHeaderDiv>
              {headerJSON.hierarchyViewType === 'Select' ? (
                <Select
                  style={{ width: 200, marginTop: '10px', marginRight: '10px' }}
                  // value={DeviceCode}
                  placeholder="Select Equipment"
                  value={DeviceCode}
                  onChange={setDeviceCode}>
                  {/* {headerJSON && headerJSON.hierarchyViewType === "Tree Drawer" && (
                    <Option key={'All'} value={'All'}>
                      All
                    </Option>
                  )} */}
                  {deviceList && Array.isArray(deviceList) &&
                    deviceList.map((device, index) => (
                      <Option key={index} value={device.Value}>
                        {device.Key}
                      </Option>
                    ))}
                </Select>
              ) : null}

              {headerJSON &&
                headerJSON &&
                headerJSON.hierarchyViewType === 'Tree Select' ? (
                <HierarchyDropdownSelection headerJSON={headerJSON} checkedArray={checkedValue || []} handleDropdownChange={hierarchyDropdownChange} />
              ) : null}

              {headerJSON && headerJSON.DashboardLevelSelection === 'dateMonthYearPicker' ? (
                <DayMonthYearSelection
                  dashboards={headerJSON}
                  headerJSON={headerJSON}
                  selectionpayload={selectionpayload}
                  dashboardName={dashboardName}
                  graphprops={panels[0] || {}}
                />
              ) : null}
              {headerJSON && headerJSON.DashboardLevelSelection === 'datePicker' ? (
                <DatePicker
                  style={{ marginTop: '10px', marginRight: '10px' }}
                  format="YYYY-MM-DD"
                  onChange={onChangeDatePicker}
                  value={dayjs(selectionDate)}
                  disabledDate={disabledDate}
                  allowClear={false}
                />
              ) : null}
              {headerJSON && headerJSON.DashboardLevelSelection === 'dateRangePicker' ? (
                <RangePicker
                  showTime
                  style={{ marginTop: '10px', marginRight: '10px' }}
                  placeholder={['Start Date', 'End Date']}
                  value={[dayjs(selectionDateRange.startDate), dayjs(selectionDateRange.endDate)]}
                  disabledDate={disabledDate}
                  onChange={onDateRangePickerChange}
                />
              ) : null}
              {headerJSON && headerJSON.DashboardLevelSelection === 'monthPicker' ? (
                <MonthPicker
                  style={{ marginTop: '10px', marginRight: '10px' }}
                  disabledDate={disabledDate}
                  placeholder="Select month"
                  onChange={onChangeMonthPicker}
                  format="YYYY-MM"
                  value={dayjs(selectionMonth, 'YYYY-MM')}
                />
              ) : null}

            </DashboardHeaderDiv>
          ) : null}
        <div>
          {panels && panels.length > 0 && !loading ? (
            <Panel
              {...props}
              dashboardName={dashboardName}
              panels={panels}
              drilldownRedirect={drilldownRedirect}
              editGraph={editGraph}
              DeviceCode={
                dropdownSelection && Object.keys(dropdownSelection).length > 0
                  ? dropdownSelection.DeviceCode
                  : DeviceCode
              }
              AssetCode={AssetCode}
              selectionDate={selectionDate}
              selectionMonth={selectionMonth}
              selectionWeek={selectionWeek}
              selectionDateRange={selectionDateRange}
              dayMonthYear={dayMonthYear}
              shift={shift}
              divWidth={props.divWidth}
              navigationMode={props.navigationMode}
              dropdownSelection={dropdownSelection}
              headerJSON={headerJSON}
            />
          ) : (
            <div style={{ textAlign: 'center', color: 'white' }}>
              <h2 style={{ color: 'white' }}>No Panels Configured</h2>
            </div>
          )}
        </div>
      </DashboardDiv>
    );
  }
};


const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  selectedTheme: state.ThemeReducer.theme,
  selectedThemeing: state.ThemeReducer.themeing
});

export default connect(mapStateToProps)(Dashboard);
